/* eslint-disable no-unused-vars */

export enum DashboardSubMenuRoutes {
  DEFAULT_ADMIN = '/support',
  DEFAULT = '/support',
  OUTREACH_DASH = '/outreach',
  SUPPORT_DASH = '/support',
}
